import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'brand-header',
  name: '品牌头部',
  icon: '品',
  group: '国学组件',
  description: '展示准准品牌、日签和新人福利入口。',
  defaultProps: {
    brandName: '准准',
    subtitle: '',
    slogan: '',
    avatarText: '准',
    signLabel: '日签',
    signLink: '/pages/guoxue/daily-sign',
    newcomerLabel: '新人',
    newcomerLink: '/pages/guoxue/wallet',
    messageLink: '/pages/guoxue/app?pageCode=message'
  }
}
